import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
  Collapse,
} from "reactstrap"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import SweetAlert from "react-bootstrap-sweetalert"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

//empty state
import UgiftEmptyState from "./UgiftEmptyState"
import emptyImage from "assets/images/ugifts/icons/empty/empty_friend.png"
import emptySearchImage from "assets/images/ugifts/icons/empty/empty_search.png"

import { Button } from "@material-ui/core"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const Friends = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [listType, setListType] = useState("list_friend")
  const [fbToken, setFbToken] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    }

    if (localStorage.getItem("fbToken")) {
      setFbToken(localStorage.getItem("fbToken"))
      console.log(localStorage.getItem("fbToken"))
    }

    if (query.get("type")) {
      setListType(query.get("type"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      setFriendData([])
      getUserProfile()
      getFriendList()
      getFriendRequestList()
      console.log("use effect")
    }
  }, [token, listType])

  const [userData, setUserData] = useState(null)
  const getUserProfile = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_profile")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUserData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [friendData, setFriendData] = useState(null)
  const getFriendList = async () => {
    if (listType == "list_facebook") {
      // getFriendListWithFb()
      if (userData.fb_account_id) getFbFriendList()
      else setFriendData([])
      return
    }

    var urlencoded = new URLSearchParams()
    urlencoded.append("option", listType)
    urlencoded.append("member_id", uid)
    if (searchData) urlencoded.append("filter_by_name", searchData)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setFriendData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [friendRequestCount, setFriendRequestCount] = useState(0)
  const getFriendRequestList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_friend_request")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setFriendRequestCount(postresponse.table.length)
    } else {
      // seterror_alert(true)
    }
  }

  function onClickFBLogin() {
    FB.login(function (response) {
      if (response.authResponse) {
        console.log("Welcome!  Fetching your information.... ")
        FB.api(
          "/me?fields=id,name,email,picture.width(300).height(300)",
          function (response) {
            console.log("Good to see you", response)
            if (!userData.fb_account_id) updateFacebookID(response.id)
          }
        )
      } else {
        console.log("User cancelled login or did not fully authorize.")
      }
    })
  }

  const updateFacebookID = async fid => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "update_facebook_id")
    urlencoded.append("member_id", uid)
    urlencoded.append("facebook_id", fid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request update fb id", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200 && postresponse.success) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      getUserProfile()
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Login failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const [fbFriendData, setFbFriendData] = useState(null)
  const getFbFriendList = async () => {
    console.log("Request fb friend")
    FB.api("/me?fields=friends", function (response) {
      console.log("Good to see you", response)
      setFbFriendData(response.friends.data)
    })

    // const response = await fetch(
    //   "https://graph.facebook.com/v12.0/me?fields=friends&access_token=" +
    //     fbToken
    // )
    // const postresponse = await response.json()
    // // response.body
    // // setPostResponse(postresponse)
    // console.log(response.status, postresponse)

    // if (response.status == 200) {
    //   // history.push("/tables-applicationtable")
    //   // setBasketData(postresponse.table)
    //   // getFriendList()
    //   // getFriendRequestList()
    //   setFbFriendData(postresponse.friends.data)
    // } else {
    //   // seterror_alert(true)
    // }
  }

  useEffect(() => {
    if (fbFriendData) getFriendListWithFb()
  }, [fbFriendData])

  const getFriendListWithFb = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "facebook_member")
    urlencoded.append("member_id", uid)
    urlencoded.append("contact", JSON.stringify(fbFriendData)) //gift or myself

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request friend facebook", JSON.stringify(fbFriendData))

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      // getFriendList()
      // getFriendRequestList()
      setFriendData(postresponse.table)
      getFriendRequestList()
    } else {
      // seterror_alert(true)
    }
  }

  const addFriend = async fid => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "add_friend")
    urlencoded.append("member_id", uid)
    urlencoded.append("friend_id", fid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request add friend", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      getFriendList()
      getFriendRequestList()
    } else {
      // seterror_alert(true)
    }
  }

  const acceptFriend = async fid => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "accept_friend")
    urlencoded.append("member_id", uid)
    urlencoded.append("friend_id", fid) //gift or myself

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request accept friend", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      getFriendList()
      getFriendRequestList()
    } else {
      // seterror_alert(true)
    }
  }

  const rejectFriend = async fid => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "reject_friend")
    urlencoded.append("member_id", uid)
    urlencoded.append("friend_id", fid) //gift or myself

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request reject friend", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      getFriendList()
      getFriendRequestList()
    } else {
      // seterror_alert(true)
    }
  }

  const [friendToDelete, setFriendToDelete] = useState(null)
  const removeFriend = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "remove_friend")
    urlencoded.append("member_id", uid)
    urlencoded.append("friend_id", friendToDelete) //gift or myself

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      getFriendList()
    } else {
      // seterror_alert(true)
    }
  }

  const [searchData, setSearchData] = useState("")

  function onSubmitSearchField(e) {
    e.preventDefault()
    getFriendList()
  }

  function onChangeSearchField(e) {
    setSearchData(e.target.value)
  }

  const [modal_removeFriend, setmodal_removeFriend] = useState(false)
  const [nameToRemove, setNameToRemove] = useState("")
  function tog_removeFriend(id, name) {
    setmodal_removeFriend(!modal_removeFriend)
    setFriendToDelete(id)
    setNameToRemove(name)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  // history.push("/tables-projecttable")
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: listType == "list_friend" ? "172px" : "128px",
                  backgroundColor:
                    friendData && friendData.length > 0 ? "#F5F5F5" : "white",
                  paddingBottom: "130px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {props.t("Friends")}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                      </Col>
                    </Row>
                    <Row
                      className="m-0 w-100 p-3"
                      style={{
                        height: listType == "list_friend" ? "100px" : "56px",
                        backgroundColor: "white",
                        position: "fixed",
                        top: 56,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col>
                        <Row>
                          <Col xs="auto" className="ps-0">
                            <button
                              className={
                                listType == "list_friend"
                                  ? "btn btn-rounded btn-primary py-0 font-size-14"
                                  : "btn btn-rounded btn-outline-light py-0 font-size-14"
                              }
                              style={{ maxHeight: "24px" }}
                              onClick={() => {
                                setListType("list_friend")
                              }}
                            >
                              {props.t("Ugift Friends")}
                            </button>
                          </Col>
                          <Col xs="auto" className="ps-0">
                            <button
                              className={
                                listType == "list_facebook"
                                  ? "btn btn-rounded btn-primary py-0 font-size-14"
                                  : "btn btn-rounded btn-outline-light py-0 font-size-14"
                              }
                              style={{ maxHeight: "24px" }}
                              onClick={() => {
                                // history.goBack()
                                // addFriend()
                                // getFriendListWithFb()
                                setListType("list_facebook")
                              }}
                            >
                              {props.t("Facebook")}
                            </button>
                          </Col>
                          <Col xs="auto" className="ps-0">
                            <button
                              className={
                                listType == "list_friend_request"
                                  ? "btn btn-rounded btn-primary py-0 font-size-14"
                                  : "btn btn-rounded btn-outline-light py-0 font-size-14"
                              }
                              style={{ maxHeight: "24px" }}
                              onClick={() => {
                                setListType("list_friend_request")
                              }}
                            >
                              {friendRequestCount > 0
                                ? props.t("Request") +
                                  " (" +
                                  friendRequestCount +
                                  ")"
                                : props.t("Request")}
                            </button>
                          </Col>
                        </Row>
                        {listType == "list_friend" && (
                          <Row>
                            <Col
                              className="px-0"
                              style={{
                                paddingTop: "14px",
                                paddingBottom: "14px",
                              }}
                            >
                              <form
                                className="app-search"
                                style={{ padding: 0 }}
                                onSubmit={onSubmitSearchField}
                              >
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder={"Search by name"}
                                    // value={companyvaluesearch}
                                    onChange={onChangeSearchField}
                                    style={{
                                      borderRadius: "8px",
                                      maxHeight: "28px",
                                      background: "white",
                                      border: "1px",
                                      borderColor: "#D6D6D6",
                                      borderStyle: "solid",
                                    }}
                                  />
                                  <span
                                    className="bx bx-search-alt"
                                    style={{ lineHeight: "28px" }}
                                  />
                                </div>
                              </form>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                    {friendData &&
                      listType == "list_friend" &&
                      friendData.map((data, index) => (
                        <Row>
                          <Col>
                            <Card
                              className="mb-0 shadow-none"
                              style={{
                                borderRadius: "0",
                                borderBottom: "1px",
                                borderBottomColor: "#D6D6D6",
                                borderBottomStyle: "solid",
                              }}
                            >
                              <Row className="p-3">
                                <Col xs="auto">
                                  {data.friend_profile_picture ? (
                                    <div>
                                      <img
                                        src={data.friend_profile_picture}
                                        className="rounded-circle avatar-sm"
                                        alt=""
                                        style={{
                                          maxWidth: "36px",
                                          maxHeight: "36px",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      className="avatar-sm"
                                      style={{
                                        maxWidth: "36px",
                                        maxHeight: "36px",
                                      }}
                                    >
                                      <span
                                        className={
                                          "avatar-title rounded-circle bg-primary text-white font-size-16"
                                        }
                                      >
                                        {data.friend_name &&
                                          data.friend_name.charAt(0)}
                                      </span>
                                    </div>
                                  )}
                                  {/* <div className="avatar-xs mx-auto">
                                    <img
                                      src={data.friend_profile_picture}
                                      className="rounded-circle avatar-xs"
                                      alt=""
                                    />
                                  </div> */}
                                </Col>
                                <Col className="align-self-center">
                                  <span className="font-size-15 text-dark">
                                    {data.friend_name}
                                  </span>
                                </Col>
                                <Col xs="auto">
                                  <button
                                    className="btn btn-link"
                                    onClick={() =>
                                      tog_removeFriend(
                                        data.friend_id,
                                        data.friend_name
                                      )
                                    }
                                  >
                                    <i className="bx bx-dots-horizontal-rounded align-middle font-size-20 text-dark" />
                                  </button>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      ))}
                    {friendData &&
                      listType == "list_facebook" &&
                      friendData.map((data, index) => (
                        <Row>
                          <Col>
                            <Card
                              className="mb-0 shadow-none"
                              style={{
                                borderRadius: "0",
                                borderBottom: "1px",
                                borderBottomColor: "#D6D6D6",
                                borderBottomStyle: "solid",
                              }}
                            >
                              <Row className="p-3">
                                <Col xs="auto">
                                  {data.profile_picture ? (
                                    <div>
                                      <img
                                        src={data.profile_picture}
                                        className="rounded-circle avatar-sm"
                                        alt=""
                                        style={{
                                          maxWidth: "36px",
                                          maxHeight: "36px",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      className="avatar-sm"
                                      style={{
                                        maxWidth: "36px",
                                        maxHeight: "36px",
                                      }}
                                    >
                                      <span
                                        className={
                                          "avatar-title rounded-circle bg-primary text-white font-size-16"
                                        }
                                      >
                                        {data.name && data.name.charAt(0)}
                                      </span>
                                    </div>
                                  )}
                                  {/* <div className="avatar-xs mx-auto">
                                    <img
                                      src={data.friend_profile_picture}
                                      className="rounded-circle avatar-xs"
                                      alt=""
                                    />
                                  </div> */}
                                </Col>
                                <Col className="align-self-center">
                                  <span className="font-size-15 text-dark">
                                    {data.name}
                                  </span>
                                </Col>
                                <Col xs="auto" className="align-self-center">
                                  <button
                                    className={
                                      data.status == ""
                                        ? "btn btn-rounded btn-primary py-0 font-size-14"
                                        : "btn btn-rounded btn-outline-primary py-0 font-size-14"
                                    }
                                    style={{ maxHeight: "24px" }}
                                    onClick={() => {
                                      data.status == "" && addFriend(data.id)
                                      // data.status == "Pending" && addFriend(data.id)
                                      data.status == "Pending Approval" &&
                                        setListType("list_friend_request")
                                    }}
                                  >
                                    {data.status == "" && props.t("Add")}
                                    {data.status == "Pending" &&
                                      props.t("Requested")}
                                    {data.status == "Pending Approval" &&
                                      props.t("Pending Approval")}
                                    {data.status == "Accepted" &&
                                      props.t("Added")}
                                  </button>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      ))}
                    {friendData &&
                      listType == "list_friend_request" &&
                      friendData.map((data, index) => (
                        <Row>
                          <Col>
                            <Card
                              className="mb-0 shadow-none"
                              style={{
                                borderRadius: "0",
                                borderBottom: "1px",
                                borderBottomColor: "#D6D6D6",
                                borderBottomStyle: "solid",
                              }}
                            >
                              <Row className="p-3">
                                <Col xs="auto">
                                  {data.friend_profile_picture ? (
                                    <div>
                                      <img
                                        src={data.friend_profile_picture}
                                        className="rounded-circle avatar-sm"
                                        alt=""
                                        style={{
                                          maxWidth: "36px",
                                          maxHeight: "36px",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      className="avatar-sm"
                                      style={{
                                        maxWidth: "36px",
                                        maxHeight: "36px",
                                      }}
                                    >
                                      <span
                                        className={
                                          "avatar-title rounded-circle bg-primary text-white font-size-16"
                                        }
                                      >
                                        {data.friend_name &&
                                          data.friend_name.charAt(0)}
                                      </span>
                                    </div>
                                  )}
                                  {/* <div className="avatar-xs mx-auto">
                                    <img
                                      src={data.friend_profile_picture}
                                      className="rounded-circle avatar-xs"
                                      alt=""
                                    />
                                  </div> */}
                                </Col>
                                <Col className="ps-0">
                                  <Row className="mb-2">
                                    <Col>
                                      <span className="font-size-15 text-dark">
                                        {data.friend_name}
                                      </span>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs="auto">
                                      <button
                                        className={
                                          "btn btn-rounded btn-primary py-0 font-size-14"
                                        }
                                        style={{ maxHeight: "24px" }}
                                        onClick={() => {
                                          acceptFriend(data.member_id)
                                        }}
                                      >
                                        {props.t("Approve")}
                                      </button>
                                    </Col>
                                    <Col xs="auto" className="ps-0">
                                      <button
                                        className={
                                          "btn btn-rounded btn-light py-0 font-size-14 text-dark"
                                        }
                                        style={{
                                          maxHeight: "24px",
                                          backgroundColor: "#D6D6D6",
                                        }}
                                        onClick={() => {
                                          rejectFriend(data.member_id)
                                        }}
                                      >
                                        {props.t("Remove")}
                                      </button>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      ))}
                    {friendData &&
                      friendData.length == 0 &&
                      listType != "list_facebook" && (
                        <UgiftEmptyState
                          image={
                            listType == "list_friend" && searchData != ""
                              ? emptySearchImage
                              : emptyImage
                          }
                          title={
                            listType == "list_friend_request"
                              ? props.t("You have no friend requests yet")
                              : searchData != ""
                              ? props.t("Your search has no result")
                              : props.t("You have no friends yet")
                          }
                          link={null}
                          linkText=""
                        />
                      )}
                    {friendData &&
                      userData &&
                      friendData.length == 0 &&
                      listType == "list_facebook" &&
                      (userData.fb_account_id ? (
                        <UgiftEmptyState
                          image={
                            listType == "list_friend" && searchData != ""
                              ? emptySearchImage
                              : emptyImage
                          }
                          title={
                            listType == "list_friend_request"
                              ? props.t("You have no friend requests yet")
                              : searchData != ""
                              ? props.t("Your search has no result")
                              : props.t("You have no friends yet")
                          }
                          link={null}
                          linkText=""
                        />
                      ) : (
                        <div>
                          <UgiftEmptyState
                            image={emptyImage}
                            title={props.t("You are not connected to Facebook")}
                            link={null}
                            linkText={props.t("Connect to facebook")}
                          />
                          <Row className="px-3">
                            <Col>
                              <button
                                className="btn btn-block waves-effect waves-light w-100 font-size-18"
                                style={{
                                  backgroundColor: "#1877F2",
                                  color: "white",
                                  borderRadius: "4px",
                                }}
                                onClick={onClickFBLogin}
                              >
                                <i className="bx bxl-facebook-circle font-size-20 align-middle me-2 text-white"></i>{" "}
                                <strong>props.t{"Connect to Facebook"}</strong>
                              </button>
                            </Col>
                          </Row>
                        </div>
                      ))}
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "130px",
                        backgroundColor: "#ffffff",
                        position: "fixed",
                        bottom: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                        boxShadow: "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                      }}
                    >
                      <Col className="h-100 p-0">
                        <Row className="mt-3">
                          <Col xs="auto" className="align-self-center mx-auto">
                            <span className="align-middle font-size-15 h-100">
                              {props.t("Invite your friends to join Ugift")}
                            </span>
                          </Col>
                        </Row>
                        <Card body className="mb-0 p-3">
                          <Link
                            to="/invite-friend"
                            className="btn btn-danger waves-effect waves-light font-size-18"
                            // style={{ height: "42px" }}
                          >
                            {props.t("Invite Friends")}
                          </Link>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={modal_removeFriend}
        toggle={() => {
          tog_removeFriend(null, "")
        }}
        // className="modal-fullscreen"
        centered={true}
      >
        {/* <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {"Friend Action"}
          </h5>
          <button
            type="button"
            onClick={() => {
              tog_removeFriend()
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div> */}
        <div className="modal-body">
          <Row className="mb-2 px-3">
            <button
              type="button"
              onClick={() => {
                removeFriend()
                tog_removeFriend()
              }}
              className="btn btn-danger waves-effect waves-light font-size-18"
              data-dismiss="modal"
            >
              {props.t("Unfriend") + " " + nameToRemove}
            </button>
          </Row>
          {/* <Row className="mb-2 px-3">
            <button
              type="button"
              onClick={() => {
                tog_removeFriend(null, "")
              }}
              className="btn btn-secondary waves-effect font-size-18"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </Row> */}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_removeFriend(null, "")
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Cancel")}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(Friends)

Friends.propTypes = {
  t: PropTypes.any,
}
